








import Vue from 'vue';
import { AccountDashboardMixin } from '@/mixins';
import SetupCompanyMixin from '../setup/company/SetupCompanyMixin';
import CompanyTabs from './CompanyTabs.vue';
import AccountToolbar from '../AccountToolbar.vue';

export default Vue.extend({
  mixins: [SetupCompanyMixin, AccountDashboardMixin],
  props: {
    companyId: {
      type: String,
      required: true,
    },
    tab: {
      type: String,
      default: 'campaigns',
    },
    reportId: String,
  },
  components: {
    CompanyTabs,
    AccountToolbar,
  },
});
